import { render } from "./MLoader.vue?vue&type=template&id=99712328&scoped=true"
import script from "./MLoader.vue?vue&type=script&lang=js"
export * from "./MLoader.vue?vue&type=script&lang=js"

import "./MLoader.vue?vue&type=style&index=0&id=99712328&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99712328"]])

export default __exports__